import React, { useState } from 'react';
import { useAuth } from '../hooks/useAuth';

const Profile: React.FC = () => {
  const { user } = useAuth();
  const [editing, setEditing] = useState(false);
  const [saved, setSaved] = useState(false);
  const [form, setForm] = useState({ full_name: user?.full_name || '', phone: '', license_number: '' });

  const handleSave = () => { setSaved(true); setEditing(false); setTimeout(() => setSaved(false), 3000); };
  const field = (label: string, value: string, key: keyof typeof form) => (
    <div>
      <label className="block text-xs font-medium text-gray-500 mb-1">{label}</label>
      {editing ? (
        <input value={form[key]} onChange={e => setForm(p => ({ ...p, [key]: e.target.value }))}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
      ) : <p className="text-sm text-gray-900 py-2">{value || '—'}</p>}
    </div>
  );

  return (
    <div className="space-y-6 max-w-2xl">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-gray-900">Your Profile</h1>
        {saved && <span className="text-sm text-green-600 font-medium">✓ Saved</span>}
      </div>
      <div className="bg-white rounded-xl border border-gray-200 p-6 space-y-6">
        <div className="flex items-center gap-4">
          <div className="h-16 w-16 rounded-full bg-blue-600 flex items-center justify-center text-white text-2xl font-bold">
            {user?.full_name?.[0]?.toUpperCase() ?? 'U'}
          </div>
          <div>
            <p className="text-lg font-semibold text-gray-900">{user?.full_name}</p>
            <p className="text-sm text-gray-500 capitalize">{user?.role} · Life & Wealth Solutions</p>
          </div>
        </div>
        <div className="border-t border-gray-100 pt-6 grid grid-cols-1 sm:grid-cols-2 gap-6">
          {field('Full Name', form.full_name, 'full_name')}
          <div><label className="block text-xs font-medium text-gray-500 mb-1">Email Address</label>
            <p className="text-sm text-gray-900 py-2">{user?.email}</p></div>
          {field('Phone Number', form.phone, 'phone')}
          {field('License Number', form.license_number, 'license_number')}
          <div><label className="block text-xs font-medium text-gray-500 mb-1">Role</label>
            <p className="text-sm text-gray-900 py-2 capitalize">{user?.role}</p></div>
          <div><label className="block text-xs font-medium text-gray-500 mb-1">Account Status</label>
            <span className="inline-flex items-center gap-1.5 px-2.5 py-1 bg-green-100 text-green-700 rounded-full text-xs font-medium">
              <span className="w-1.5 h-1.5 bg-green-500 rounded-full" />Active
            </span></div>
        </div>
        <div className="border-t border-gray-100 pt-4 flex gap-3">
          {editing ? (
            <><button onClick={handleSave} className="px-4 py-2 bg-blue-600 text-white text-sm rounded-lg hover:bg-blue-700">Save Changes</button>
            <button onClick={() => setEditing(false)} className="px-4 py-2 bg-gray-100 text-gray-700 text-sm rounded-lg hover:bg-gray-200">Cancel</button></>
          ) : (
            <button onClick={() => setEditing(true)} className="px-4 py-2 bg-blue-600 text-white text-sm rounded-lg hover:bg-blue-700">Edit Profile</button>
          )}
        </div>
      </div>
    </div>
  );
};
export default Profile;
